(() => {
  const unsafePath = /^\/(?:cart|checkout|account|challenge)(?:\/|$)/;
  const catalogFallbackPath = /^\/(?:products|search)(?:\/|$)/;
  const marketPrefix = /^\/(?:sk-sk|ro-ro|hu-hu)(?=\/|$)/;

  const safePath = () => {
    const path = window.location.pathname.replace(marketPrefix, '') || '/';
    if (catalogFallbackPath.test(path)) return '/collections/all';
    return unsafePath.test(path) ? '/' : path;
  };

  const init = (switcher) => {
    if (switcher.dataset.initialized === 'true') return;
    switcher.dataset.initialized = 'true';

    const warning = switcher.dataset.cartWarning || '';
    const hasCartItems = Number.parseInt(switcher.dataset.cartCount || '0', 10) > 0;

    switcher.querySelectorAll('[data-mv-market-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (link.getAttribute('aria-current') === 'true') {
          event.preventDefault();
          switcher.removeAttribute('open');
          return;
        }

        if (hasCartItems && warning && !window.confirm(warning)) {
          event.preventDefault();
          return;
        }

        event.preventDefault();

        try {
          window.localStorage.setItem('mercavelo-market-choice', link.dataset.marketBase);
        } catch (_) {
          // Storage can be unavailable in strict privacy modes; navigation still works.
        }
        window.location.assign(`${link.dataset.marketBase}${safePath()}`);
      });
    });

    switcher.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      switcher.removeAttribute('open');
      switcher.querySelector('summary')?.focus();
    });

    document.addEventListener('click', (event) => {
      if (!switcher.open || switcher.contains(event.target)) return;
      switcher.removeAttribute('open');
    });

    const suggestion = document.querySelector('[data-mv-market-suggestion]');
    if (!suggestion || suggestion.dataset.initialized === 'true') return;
    suggestion.dataset.initialized = 'true';

    const currentMarket = suggestion.dataset.currentMarket;
    const preferredMarket = (navigator.languages || [navigator.language])
      .map((language) => language?.toLowerCase().split('-')[0])
      .find((language) => ['sk', 'ro', 'hu'].includes(language));

    if (!preferredMarket || preferredMarket === currentMarket) return;

    const target = switcher.querySelector(`[data-market-code="${preferredMarket}"]`);
    if (!target) return;

    const dismissKey = `mercavelo-market-dismissed-${currentMarket}-${preferredMarket}`;
    try {
      if (window.localStorage.getItem(dismissKey) === 'true') return;
    } catch (_) {
      // A suggestion can still be shown when storage is unavailable.
    }

    const replaceToken = (template, token, value) => (template || '').replace(token, value || '');
    const language = target.dataset.marketLanguage;
    const country = target.dataset.marketCountry;
    const message = replaceToken(suggestion.dataset.messageTemplate, '{language}', language);
    const action = replaceToken(suggestion.dataset.actionTemplate, '{market}', country);

    suggestion.querySelector('[data-mv-suggestion-badge]').textContent = preferredMarket.toUpperCase();
    suggestion.querySelector('[data-mv-suggestion-message]').textContent = message;

    const suggestionLink = suggestion.querySelector('[data-mv-suggestion-link]');
    suggestionLink.textContent = action;
    suggestionLink.href = `${target.dataset.marketBase}${safePath()}`;
    suggestionLink.addEventListener('click', (event) => {
      if (hasCartItems && warning && !window.confirm(warning)) {
        event.preventDefault();
      }
    });

    suggestion.querySelector('[data-mv-suggestion-dismiss]').addEventListener('click', () => {
      try {
        window.localStorage.setItem(dismissKey, 'true');
      } catch (_) {
        // Dismissal remains effective for the current page.
      }
      suggestion.hidden = true;
    });

    suggestion.hidden = false;
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-mv-market-switcher]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
